import React from "react";
import PropTypes from "prop-types";

import { Header } from "semantic-ui-react";

import withPrivacyMode from "components/PrivacyMode/WithPrivacyMode";
import Selector from "components/Selector";

export function SimpleContactSelector({
  title,
  className,
  selected,
  data,
  onUpdateSearchText,
  onSelect,
  loading,
  disabled,
  hasMorePages,
  readNext,
}) {
  return (
    <div
      data-test="contact-selector"
      style={{ minWidth: "250px", width: "100%" }}
    >
      {title && (
        <Header as="h4" style={{ marginBottom: "1em" }}>
          {title}
        </Header>
      )}
      <Selector
        name="contacts"
        dropdownProps={{
          selectOnBlur: false,
          selectOnNavigation: false,
          placeholder: loading ? "Loading contacts..." : "Select a contact",
          noResultsMessage: loading ? "" : "No contacts available",
          loading: loading,
          disabled: disabled,
          className: `fs-block dd-privacy-mask  ${className}`,
          onBlur: () => {
            onUpdateSearchText("");
          },
          onSearchChange: (e) => {
            onUpdateSearchText(e.target.value);
          },
        }}
        selection={(data || []).map(({ id, name }) => {
          return { key: id, value: id, text: name };
        })}
        selected={selected?.id || null}
        showLoadMore={hasMorePages}
        loadMoreData={readNext}
        onOpen={readNext}
        multiple={false}
        onSelect={(value) => {
          onSelect(
            data.find(({ id }) => {
              return id === value;
            })
          );
        }}
      />
    </div>
  );
}

SimpleContactSelector.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  hasMorePages: PropTypes.bool,
  readNext: PropTypes.func,
  onUpdateSearchText: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

SimpleContactSelector.defaultProps = {
  title: "Select Target Contact",
  className: undefined,
  selected: null,
  loading: false,
  disabled: false,
  data: [],
  readNext: () => {},
  hasMorePages: false,
};

export default withPrivacyMode(SimpleContactSelector);
